var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main"},[_c('img',{attrs:{"src":require("../assets/img/fabrica.jpg"),"width":"101%","alt":"fabrica"}})])
}]

export { render, staticRenderFns }